<div class="points-summary-bar d-flex justify-content-between align-items-center mt-2 d-lg-none">
  <!-- Back Button -->
  <div class="back-btn text-white cursor-pointer d-lg-none gloss-black" [routerLink]="[backButtonLink]">
    <span class="material-icons"> arrow_back_ios </span>
  </div>
</div>
